import { useEffect, useState } from 'react';
import api from '..';

import { OptionsRequests, RequestName, RequestValue } from './types';

const optionsRequests: OptionsRequests = {
  paymentTypes: 'core/dominios/meios-pagamento',
  invoiceTypes: 'core/dominios/tipo-fatura',
  dueDates: 'core/dominios/vencimentos',
  banks: 'core/dominios/bancos',
  locations: 'core/dominios/locais',
};

const getRequests = async (name: string) => {
  try {
    const requestUrl = optionsRequests[name as RequestName];
    const { data } = await api.get<RequestValue[]>(requestUrl);
    return { data, name: name as RequestName };
  } catch {
    return { data: [], name: name as RequestName };
  }
};
type Result = { [key in RequestName]: RequestValue[] };
export const useOptions = () => {
  const [result, setResult] = useState<Result>({} as Result);

  useEffect(() => {
    const requests = Object.keys(optionsRequests).map(getRequests);
    Promise.all(requests).then((options) => {
      const resultFormatted = {} as Result;
      options.forEach((option) => {
        resultFormatted[option.name] = option.data;
      });
      setResult(resultFormatted);
    });
  }, []);

  return { result };
};
